import { IHolidaysModalProps } from "./HolidaysModalTypes"

import { useUI } from "providers/UIProvider"

import { Container, Box, Center, Text } from "@chakra-ui/react"
import Modal from "components/UI/organisms/Modal"
import AddEditHolidayModal from "../AddEditHolidayModal"
import HolidayItem from "./HolidayItem"
import Button from "components/UI/atoms/Button"
import Icon from "components/UI/atoms/Icon"
import useHolidays from "hooks/useHolidays"
import { useAppContext } from "providers/AppProvider/AppProvider"

const HolidaysModal: React.FC<IHolidaysModalProps> = () => {
  const { modals, toggleModal, T } = useUI()
  const { holidays } = useAppContext()
  const { handleDeleteClick, handleAddEditClick } = useHolidays(null)
 
  return (
    <Modal
      isOpen={modals.holidaysModal.isOpened}
      onClose={()=>toggleModal("holidaysModal", false)}
      title={T("general.holiday")}
      styles={{
        headerPadding: "15px 15px 15px 25px",
        bodyPadding: "25px 13px",
      }}
    >
      <Container>
        <Center style={{ justifyContent: "center"}}>
          <Text fontSize="xl">{T("general.holiday_days")}</Text>
        </Center>
        <Box mt="30px" maxHeight="400px" overflow="auto">
          {holidays.data?.map( (holiday: any) => (
            <HolidayItem key={holiday.id} holiday={holiday} handleDeleteClick={handleDeleteClick} handleEditClick={handleAddEditClick} />
          ))}
          {holidays.data?.length === 0 && (
            <Center style={{justifyContent: "center"}}>
              {T("general.empty_states.no_holidays_found")}
            </Center>
          )}
        </Box>
        <Center mt="30px">
          <Button
            text={T("general.add_holiday")}
            onClick={()=>handleAddEditClick(null)}
            leftIcon={
              <Icon
                name="add_circle"
                iconStyles={{ width: "40px", height: "40px" }}
              />
            }
            variant="solid_dark_gray"
            styles={{ fontSize: "xl", width: "380px", height: "80px" }}
          />
        </Center>
        <AddEditHolidayModal />
      </Container>
    </Modal>
  )
}

export default HolidaysModal
